import { Duration } from 'luxon';

export const TELEMATICS_OUTDATED_THRESHOLD = Duration.fromObject({
  hours: 8,
});
